export enum SignUpStep {
  TYPE_AND_EMAIL = 1,
  OWNER_TYPE,
  OWNER_DETAILS,
  OWNER_CONFIRM,
  BUSINESS_STRUCTURE,
  BUSINESS_ABN,
  BUSINESS_DETAILS,
  BUSINESS_COMPANY_DETAILS,
  TRUSTEE_DETAILS,
  TRUSTEE_COMPANY_DETAILS,
  USER_DETAILS,
  ONE_TIME_CODE,
  CHANGE_EMAIL,
  CREATE_CONTRACT,
  COMPLETE_CONTRACT,
  REVIEW_CONTRACT,
  SIGN_CONTRACT,
  OWNER_INVITE_BUILDER,
  EMPLOYEE_INVITE_DIRECTOR,
  EMPLOYEE_INVITE_PARTNER,
  EMPLOYEE_INVITE_SOLE_TRADER,
  EMPLOYEE_INVITE_TRUSTEE,
}

export enum InviteJoinReason {
  OWNER_INVITE_BUILDER = 'OWNER_INVITE_BUILDER',
  EMPLOYEE_INVITE_DIRECTOR = 'EMPLOYEE_INVITE_DIRECTOR',
  EMPLOYEE_INVITE_PARTNER = 'EMPLOYEE_INVITE_PARTNER',
  EMPLOYEE_INVITE_SOLE_TRADER = 'EMPLOYEE_INVITE_SOLE_TRADER',
  EMPLOYEE_INVITE_TRUSTEE = 'EMPLOYEE_INVITE_TRUSTEE',
}

export enum SignUpTrackReason {
  OWNER_SIGN_UP = 'OWNER_SIGN_UP',
  EMPLOYEE_SIGN_UP = 'EMPLOYEE_SIGN_UP',
  TRUSTEE_COMPANY_EMPLOYEE_SIGN_UP = 'TRUSTEE_COMPANY_EMPLOYEE_SIGN_UP',
}

export enum RoleInBusiness {
  SOLE_TRADER = 'SOLE_TRADER',
  PARTNERSHIP = 'PARTNERSHIP',
  EMPLOYEE = 'EMPLOYEE',
}

export enum RoleInCompany {
  SOLE_DIRECTOR = 'SOLE_DIRECTOR',
  DIRECTOR = 'DIRECTOR',
  EMPLOYEE = 'EMPLOYEE',
}

export enum TrustType {
  INDIVIDUAL = 'INDIVIDUAL',
  MULTIPLE_INDIVIDUALS = 'MULTIPLE_INDIVIDUALS',
  OFFICER_OF_COMPANY = 'OFFICER_OF_COMPANY',
  EMPLOYEE_OF_COMPANY = 'EMPLOYEE_OF_COMPANY',
  EMPLOYEE_OF_INDIVIDUALS = 'EMPLOYEE_OF_INDIVIDUALS',
}

export enum OwnerType {
  INDIVIDUALS = 'INDIVIDUALS',
  BUSINESS = 'BUSINESS',
}
